exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".person-form[data-v-5e2db9e8]{margin-bottom:15px;padding:10px;border:1px dashed #aaa;border-radius:5px}", ""]);

// exports
